import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getUserdetails = createAsyncThunk(
  "user/userdetails",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/userdetails`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
)

export const editProfile = createAsyncThunk(
  "user/editProfile",
  async ({ token, data }, thunkAPI) => {
    try {
      // 🔍 Debug FormData correctly
      const res = await axios.post(
        `${BACKEND_URL}/update-user`,
        data, // ✅ FormData ONLY
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // ❗ DO NOT manually set boundary
            "Content-Type": "multipart/form-data",
            // "Content-Type": "application/json",
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Profile update failed"
      );
    }
  }
);


const workerEditProfileSlice = createSlice({
    name: "workerEditProfile",
    initialState: {
      Userdetails: {
        user : null
      },
      loading: false,
      error: null,
      message: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserdetails.pending, (state) => {
              state.loading = true;
              state.error = null;
            })
            .addCase(getUserdetails.fulfilled, (state, action) => {
                state.loading = false;
                state.Userdetails = action.payload;
            })
            .addCase(getUserdetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(editProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(editProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message || "Profile Update successfully";
            })
            .addCase(editProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default workerEditProfileSlice.reducer;
